import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

const ContactSection = () => {
  const contactInfo = [
    {
      icon: Phone,
      label: "Phone",
      value: "(503) 635-2139",
      link: "tel:5036352139"
    },
    {
      icon: Mail,
      label: "Email",
      value: "info@childrens-hour.com",
      link: "mailto:info@childrens-hour.com"
    },
    {
      icon: MapPin,
      label: "Address",
      value: "17650 SW 65th Avenue, Lake Oswego, OR 97035",
      link: "https://maps.google.com/?q=17650+SW+65th+Avenue,+Lake+Oswego,+OR+97035"
    },
    {
      icon: Clock,
      label: "Hours",
      value: "Monday - Friday: 7:30 AM - 5:30 PM",
      link: null
    }
  ];

  return (
    <section id="contact" className="py-10">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12 animate-fade-in-up">
            <h2 className="font-header text-3xl md:text-4xl font-bold text-white mb-4">
              Visit Us Today
            </h2>
            <p className="text-lg text-white max-w-2xl mx-auto">
              We'd love to show you around and introduce you to our community. Schedule a tour to see our programs in action.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-6 mb-12">
            {contactInfo.map((info, index) => (
              <Card 
                key={index}
                className="p-6 hover:shadow-medium transition-shadow animate-fade-in border-border"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="flex items-start gap-4">
                  <div className="h-12 w-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <info.icon className="h-6 w-6 text-primary" />
                  </div>
                  <div>
                    <p className="text-sm text-muted-foreground mb-1">{info.label}</p>
                    {info.link ? (
                      <a 
                        href={info.link} 
                        target={info.link.startsWith('http') ? '_blank' : undefined}
                        rel={info.link.startsWith('http') ? 'noopener noreferrer' : undefined}
                        className="text-foreground font-medium hover:text-primary-deep transition-colors"
                      >
                        {info.value}
                      </a>
                    ) : (
                      <p className="text-foreground font-medium">{info.value}</p>
                    )}
                  </div>
                </div>
              </Card>
            ))}
          </div>
          
          <Card className="p-8 md:p-12 bg-gradient-hero text-center animate-fade-in-up border-0">
            <h3 className="font-header text-2xl md:text-3xl font-bold text-primary-foreground mb-4">
              Ready to Join Our Community?
            </h3>
            <p className="text-primary-foreground/90 text-lg mb-8 max-w-2xl mx-auto">
              Experience the difference that Oregon's highest-rated early childhood education can make for your family.
            </p>
            <div className="flex justify-center">
              <Link to="/schedule-tour">
                <Button variant="secondary" size="lg" className="bg-card text-foreground hover:bg-purple-500 hover:text-white transition-colors">
                  Schedule a Tour
                </Button>
              </Link>
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
